import { SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { Issue } from '../../issues/components/issue';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetActivity = () => {
  const { assetId } = useParams();
  const navigate = useNavigate();

  if (!assetId) {
    return null;
  }

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={assetId} />,
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => {
      navigate(`/assets/${assetId}`);
    },
  };

  const rightColumn = {
    title: 'assets.menu.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
